import { WorkItemDetailPage } from "@/components/work-items/detail/page";
import type { WorkItemDetail } from "@/components/work-items/detail/types";
import { api } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

/** `/work-item/:globalId`, the one URL of a work item. */
export const Route = createFileRoute("/_app/work-item/$id")({
  loader: ({ params }) => api.get<WorkItemDetail>(`/api/work-items/${params.id}`),
  component: WorkItemDetailPage,
});
